import { useApi } from '@cleartax/wg-library-hooks';
import { Text } from '@cleartax/wg-library-typography';
import { useEffect } from 'react';
import { useUserCtx } from '../../../../../context/user';
import { trackAction } from '../../../../../utils';
import { logoutApi, TLogoutRes } from '../header.api';
import { MY_ACCOUNT_DROPDOWN } from './static';

export const MyAccountDropdown: React.FC = () => {
  const borderClasses = 'border-b-sm border-dashed border-b-grey-300';
  const textClasses = 'text-brand-1000 text-base font-medium';
  const containerClasses =
    'mx-2 cursor-pointer flex justify-between items-center py-3 pl-3';

  const { request: logout, data: logoutRes } = useApi<TLogoutRes>(
    {},
    logoutApi
  );

  const userContext = useUserCtx();
  useEffect(() => {
    if (logoutRes.success) userContext.logout();
  }, [logoutRes]);

  return (
    <div className="origin-top-right bg-white w-48 absolute sm:relative mt-2 rounded-b-lg shadow-lg sm:shadow-none focus:outline-none">
      {MY_ACCOUNT_DROPDOWN.map((dropdownItem, idx, arr) => {
        return (
          <div
            key={dropdownItem.name}
            className={`w-full hover:bg-brand-200 ${
              idx + 1 === arr.length ? 'rounded-b-lg' : ''
            }`}
          >
            <Text
              type="a"
              mergeClasses="override"
              href={dropdownItem.href}
              className={`${borderClasses} ${textClasses} ${containerClasses}`}
              onClick={() => {
                trackAction('click', '', {
                  label: `top_nav_menu_${dropdownItem.name}`,
                });
                if (dropdownItem.name === 'Logout') logout();
              }}
            >
              {dropdownItem.name}
            </Text>
          </div>
        );
      })}
    </div>
  );
};
